// @mui
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
//

// ----------------------------------------------------------------------
interface LogoutDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm:()=>void;
}
export default function LogoutDialog({
  open,
  onClose,
  onConfirm
}:LogoutDialogProps) {
  return (
    <Dialog fullWidth maxWidth="xs" open={open} onClose={onClose}>
      <DialogTitle sx={{ pb: 2 }}>Logout</DialogTitle>

      <DialogContent sx={{ typography: 'body2' }}> Are you sure you want to log out? </DialogContent>

      <DialogActions>
        {/* {action} */}
        <Button variant="contained" color="error" onClick={onConfirm}>
          Logout
        </Button> 
        <Button variant="outlined" color="inherit" onClick={onClose}>
          Cancel
        </Button>
       
      </DialogActions>
    </Dialog>
  );
}
